import { render, staticRenderFns } from "./InitialTemplate.vue?vue&type=template&id=7ec23873&scoped=true"
import script from "./InitialTemplate.vue?vue&type=script&lang=js"
export * from "./InitialTemplate.vue?vue&type=script&lang=js"
import style0 from "./InitialTemplate.vue?vue&type=style&index=0&id=7ec23873&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec23873",
  null
  
)

export default component.exports